<template>
    <div>
        <div class="rcvReturnSearchLayout">
            <m-assembly-table ref='pageForm'
                            :formData="formData"
                            :columns="columns"
                            :data="data"
                            :currentPage="pages"
                            :settings="settings"
                            :tableButtons="tableButtons"
                            :tableTitle="tableTitle"
                            :loading="loading"
                            :total="total"
                            :pageSize="pageSize"
                            @onSubmit="onSubmit"
                            @onPageSizeChange="onPageSizeChange"
                            @onCurrentPageChange="onCurrentPageChange"
                            @onRowClick="onRowClick"
                            @onView="onView"
                            @onEdit="onEdit"
                            @onDelete="onDelete"
                            @onSelect="onSelect"
                            @onSelectAll="onSelectAll"
                            thDrag
            ></m-assembly-table>
        </div>

        <div style="display:none">
            <iframe id="export" name="export"></iframe>
            <form name="exportPDF" id="exportXls" target="export" method="post" accept-charset="UTF-8">
                <input name="params" id="exportParams"/>
            </form>
        </div>
    </div>
</template>

<script>

    import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
    import {formatDateTime} from '@/utils/datetime-format.js';
    import axios from 'axios';
    import moment from 'moment';

    export default {
        name: 'rcvReturnSearch',
        components: {mAssemblyTable},
        // computed: {
        //     /* 根据字段判断是否使用新接口 */
        //     switchNew() {
        //         const organizationId = this.getFormDataItemVal(this.formData.items, 'organizationId');
        //         return this.INT_LOCAL_PO_ORG.some((item) => item.code === this.getOrgCode({
        //             organizationId,
        //         }));
        //     },
        // },
        data() {
            return {
                INT_LOCAL_PO_ORG: [],
                currLang: this.$i18n.locale,
                vendorUser: {},
                orgList: [],
                mdmCode: '', // IERP的供应商编码
                vendorId: 0,
                vendorCode: 0,
                organizationNameResult: [],
                condition: {},
                billStatus: [],
                isPoll: false,
                gender: '',
                loading: true,
                showExportModel: false,
                showPopDemoModel: false,
                postHeaderConf: {
                    headers: {'Content-Type': 'application/json'}
                },
                formData: {
                    row: 4,
                    items: [
                        {
                            value: '',
                            field: 'organizationId', // organization
                            disabled: false,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                multiple: false,
                                values: []
                            },
                            type: 'select',
                            title: this.$t('rcvReturnSearch.Organization'), // 库存组织
                            validators: {
                                required: {
                                    required: true,
                                    message: this.$t('common.not_empty_require') // 必须填写
                                }
                            },
                            methods: {
                                change: () => {
                                    this.data = [];
                                    this.total = 0;
                                },
                            }
                        },
                      {
                        value: new Date(),
                        field: 'transactionStart', // beginCreationDate
                        validators: {
                          required: {
                            required: true,
                            message: this.$t('rcvReturnSearch.Transaction_date_cannot_be_empty') // 事务处理日期不能为空
                          }
                        },
                        testRules: {
                          validator(rule, value, callback, source, options) {
                            var begin = new Date(value[0]);
                            var end = value[1];
                            var errors = [];
                            if ((end - begin) / (1000 * 60 * 60 * 24) > 31) {
                              errors = [this.$t('rcvReturnSearch.Query_date_range_tips1')]; // 查询日期范围不可超过31天
                            }
                            callback(errors);
                          }
                        },
                        layout: {
                          row: 1,
                          span: 8,
                          offset: 0
                        },
                        style: 'width:100%',
                        options: {
                          type: 'date',
                          format: 'yyyy-MM-dd'
                        },
                        type: 'datePicker',
                        title: this.$t('rcvReturnSearch.Transaction_Date'), // 事务处理日期
                        placeholder: this.$t('rcvReturnSearch.Date_from'), // 日期从
                        isDouble: true
                      },
                      {
                        hide: true,
                        value: new Date(),
                        field: 'transactionEnd', // endCreationDate
                        validators: {
                          required: {
                            required: true,
                            message: this.$t('rcvReturnSearch.Transaction_date_cannot_be_empty') // 事务处理日期不能为空
                          }
                        },
                        testRules: {
                          validator(rule, value, callback, source, options) {
                            var begin = new Date(value[0]);
                            var end = value[1];
                            var errors = [];
                            if ((end - begin) / (1000 * 60 * 60 * 24) > 31) {
                              errors = [this.$t('rcvReturnSearch.Query_date_range_tips1')]; // 查询日期范围不可超过31天
                            }
                            callback(errors);
                          }
                        },
                        style: 'width:100%',
                        layout: {
                          span: 4,
                          offset: 0,
                          row: 2
                        },
                        options: {
                          type: 'date',
                          format: 'yyyy-MM-dd',
                          options: {
                            disabledDate(date) {
                            }
                          }
                        },
                        type: 'datePicker'
                      },
                        {
                            value: '',
                            field: 'transactionType', // transactionType
                            disabled: false,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 1
                            },
                            options: {
                                multiple: false,
                                values: []
                            },
                            type: 'select',
                            title: this.$t('rcvReturnSearch.Transaction_Type') // 事务处理类型
                        },
                        {
                            isDouble: true,
                            value: '',
                            field: 'itemCodeStart', // itemCodeFrom
                            disabled: false,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text',
                            title: this.$t('rcvReturnSearch.Item_Code_From'), // 物料编码从
                            change: () => {
                              this.formData.items[5].value = this.formData.items[4].value;
                            }
                        },
                        {
                            hide: true,
                            value: '',
                            field: 'itemCodeEnd', // itemCodeTo
                            disabled: false,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text',
                            title: '至'
                        },
                        {
                            value: '',
                            field: 'orderNumber', // poNum
                            disabled: false,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text',
                            title: this.$t('rcvReturnSearch.Purchase_Order_No') // 采购订单号
                        },
                        {
                            value: '',
                            field: 'receiptNum', // receiptNum
                            disabled: false,
                            layout: {
                                span: 8,
                                offset: 0,
                                row: 2
                            },
                            options: {
                                rows: 1,
                                type: 'text'
                            },
                            type: 'text',
                            title: this.$t('rcvReturnSearch.Receipt_Number') // 接收单号
                        }
                        // {
                        //     value: '',
                        //     field: 'orderType', // orderType
                        //     disabled: false,
                        //     layout: {
                        //         span: 8,
                        //         offset: 0,
                        //         row: 3
                        //     },
                        //     options: {
                        //         multiple: false,
                        //         values: []
                        //     },
                        //     type: 'select',
                        //     title: this.$t('rcvReturnSearch.Order_Type') // '订单类型'
                        // }
                    ],
                    buttons: {
                        submitText: this.$t('rcvReturnSearch.Query'), // 查找
                        resetText: this.$t('rcvReturnSearch.Clear'), // 清除
                        layout: {
                            span: 24,
                            push: 8
                        }
                    }
                },
                columns: {
                    columns: [
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Organization')); // 库存组织
                            },
                            key: 'organizationName',
                            sortable: true,
                            align: 'center',
                            width: 120,
                            render: (h, params) => {
                                return h('Tooltip', {
                                    props: {
                                        content: params.row.organizationName,
                                        placement: 'top'
                                    },
                                    class: 'm-tooltip-overflow'
                                }, params.row.organizationName);
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Receipt_Number'));  // 接收单号
                            },
                            key: 'receiptNum',
                            align: 'center',
                            width: 110
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Item_Code')); // 物料编码
                            },
                            key: 'itemCode',
                            sortable: true,
                            align: 'center',
                            width: 150
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Item_Description')); // 物料描述
                            },
                            key: 'itemDescription',
                            align: 'center',
                            minWidth: 300,
                            render: (h, params) => {
                                return h('Tooltip', {
                                    props: {
                                        content: params.row.itemDescription,
                                        placement: 'top'
                                    },
                                    class: 'm-tooltip-overflow'
                                }, params.row.itemDescription);
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Unit')); // 单位
                            },
                            key: 'unit',
                            align: 'center',
                            width: 80
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Order_Number')); // 订单号
                            },
                            key: 'orderNumber',
                            align: 'center',
                            width: 150
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Receipt_Date')); // 接收日期
                            },
                            key: 'receiptDate',
                            align: 'center',
                            width: 140,
                            render: (h, params) => {
                                let {receiptDate, organizationCode} = params.row;
                                if (receiptDate) {
                                    return h('span', this.timeChange(organizationCode, receiptDate));
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Transaction_Type')); // 事务类型
                            },
                            key: 'transactionTypeName',
                            align: 'center',
                            width: 90
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Transaction_Date')); // 事务日期
                            },
                            key: 'transactionDate',
                            align: 'center',
                            width: 140,
                            render: (h, params) => {
                                let {transactionDate, organizationCode} = params.row;
                                if (transactionDate) {
                                    return h('span', this.timeChange(organizationCode, transactionDate));
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Transaction_Volume')); // 事务数量
                            },
                            key: 'transactionQuantity',
                            align: 'center',
                            width: 90
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Currency')); // 币种
                            },
                            key: 'currencyCode',
                            align: 'center',
                            width: 100
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Remarks')); // 备注
                            },
                            key: 'remarks',
                            align: 'center',
                            minWidth: 180
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Buyer')); // 采购员
                            },
                            key: 'buyer',
                            align: 'center',
                            minWidth: 200
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Order_Quantity')); // 订单数量
                            },
                            key: 'orderQuantitys',
                            align: 'center',
                            width: 110
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Order_Creation_Date')); // 订单创建日期
                            },
                            key: 'orderCreationDate',
                            align: 'center',
                            width: 140,
                            render: (h, params) => {
                                let {orderCreationDate, organizationCode} = params.row;
                                if (orderCreationDate) {
                                    return h('span', this.timeChange(organizationCode, orderCreationDate));
                                }
                            }
                        },
                        {
                            renderHeader: (h, params) => {
                                return h('span', this.$t('rcvReturnSearch.fields.Order_type')); // 订单类型
                            },
                            key: 'orderType',
                            align: 'center',
                            width: 200,
                            render: (h, params) => {
                                return h('Tooltip', {
                                    props: {
                                        content: params.row.orderType,
                                        placement: 'top'
                                    },
                                    class: 'm-tooltip-overflow'
                                }, params.row.orderType);
                            }
                        }
                    ]
                },
                tableButtons: {
                    systemButtons: [],
                    customButtons: [
                        {
                            name: '',
                            label: this.$t('rcvReturnSearch.Export'), // 导出
                            icon: 'ios-down',
                            disabled: true,
                            loading: false,
                            click: (button) => {
                                if (!this.$refs.pageForm.validateForm()) return;
                                let param = {};
                                this.formData.items.map((item) => {
                                    if (item.type === 'datePicker') {
                                        if (item.field === 'transactionStart') {
                                            param[item.field] = item.value ? formatDateTime(new Date(item.value), 'yyyy-MM-dd 00:00:00') : '';
                                        } else {
                                            param[item.field] = item.value ? (item.field === 'transactionEnd' ? formatDateTime(new Date(item.value), 'yyyy-MM-dd 23:59:59') : formatDateTime(new Date(item.value), 'yyyy-MM-dd HH:mm:ss')) : '';
                                        }
                                    } else {
                                        param[item.field] = item.value;
                                        if (item.field === 'organizationId') {
                                            this.orgList.forEach((element) => {
                                                if (element.value === this.formData.items[0].value) {
                                                    param.erpOrgId = element.erpOrgId;
                                                }
                                            });
                                        }
                                    }
                                });
                                const { transactionStart, transactionEnd } = param;
                                if (moment(moment(transactionStart).add(1, 'y').format('YYYY-MM-DD')).format('x') < moment(moment(transactionEnd).format('YYYY-MM-DD')).format('x')) {
                                    this.$Modal.warning({
                                        content: this.$t('rcvReturnSearch.Query_date_range_tips1'),  // 日期范围不可超过1年
                                    });
                                    return;
                                }
                                let params = {
                                    language: this.filterLang(), // 必填
                                    vendorCode: this.vendorCode, // 供应商编码,必填
                                    mdmCode: this.mdmCode,
                                    receiptDate: "",                // 接收日期
                                    receiptDateStart: "",           // 接收日期,开始
                                    receiptDateEnd: "",             // 接收日期,结束
                                    transactionDate: "",            // 事务日期
                                    orderCreationDate: "",          // 订单创建日期
                                    orderCreationDateStart: "",     // 订单创建日期,开始
                                    orderCreationDateEnd: "",       // 订单创建日期,结束
                                    buyer: "",                      // 采购员
                                    pageIndex: this.pages,          // 查询第几页,为空默认第一页
                                    pageSize: 99999,        // 每页查询数据量，为空默认查99999
                                    ...param
                                };
                                this.tableButtons.customButtons[0].loading = true;
                                var a = document.createElement('a');
                                // let url = '/gscint/ierp/tackBackDetail/exportIerpTackBackDetail';
                                /* 新接口需要增加参数 */
                                const url = '/gscint/gscIPoTransactions/exportTackBackDetail';
                                params.organizationCode = this.getOrgCode(params);
                                a.href =`${url}?paraJson=${encodeURI(JSON.stringify(params))}`;
                                a.style.display = 'none';
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                                setTimeout(() => {
                                    this.tableButtons.customButtons[0].loading = false;
                                }, 5000);
                            }
                        }
                    ]
                },
                data: [],
                pages: 1,
                total: 0,
                pageSize: 10,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 30, 50, 80],
                    needSearch: true,
                    needValidation: true
                },
                tableTitle: '',
                INT_TIME_ZONE: []
            };
        },
        watch: {
            billStatus: function () {
                this.formData.items[1].options.values = this.billStatus;
            },
            showPopDemoModel(val) {
                if (val) {
                    this.gender = '';
                }
            },
            total(val) {
                this.tableButtons.customButtons[0].disabled = (val === 0);
            }
        },
        methods: {
            seach() {
                this.loading = true;
                let params = {};
                this.formData.items.map((item) => {
                    if (item.type === 'datePicker') {
                        if (item.field === 'transactionStart') {
                            params[item.field] = item.value ? formatDateTime(new Date(item.value), 'yyyy-MM-dd 00:00:00') : '';
                        } else {
                            params[item.field] = item.value ? (item.field === 'transactionEnd' ? formatDateTime(new Date(item.value), 'yyyy-MM-dd 23:59:59') : formatDateTime(new Date(item.value), 'yyyy-MM-dd HH:mm:ss')) : '';
                        }
                    } else {
                        params[item.field] = item.value;
                        if (item.field === 'organizationId') {
                            this.orgList.forEach((element) => {
                                if (element.value === this.formData.items[0].value) {
                                    params.erpOrgId = element.erpOrgId;
                                }
                            });
                        }
                    }
                });
                // let url = '/gscint/ierp/tackBackDetail/queryIerpTackBackDetail';
                // /* 新接口需要增加参数 */
                // if (this.switchNew) {
                // }
                const url = '/gscint/gscIPoTransactions/queryTackBackDetail';
                params.organizationCode = this.getOrgCode(params);
                let queryParam = {
                    language: this.currLang,    // 必填
                    vendorCode: this.vendorCode,    // 供应商编码,必填
                    mdmCode: this.mdmCode,
                    receiptDate: "",                // 接收日期
                    receiptDateStart: "",           // 接收日期,开始
                    receiptDateEnd: "",             // 接收日期,结束
                    transactionDate: "",            // 事务日期
                    orderCreationDate: "",          // 订单创建日期
                    orderCreationDateStart: "",     // 订单创建日期,开始
                    orderCreationDateEnd: "",       // 订单创建日期,结束
                    buyer: "",                      // 采购员
                    pageIndex: this.pages,          // 查询第几页,为空默认第一页
                    pageSize: this.pageSize,        // 每页查询数据量，为空默认查99999
                    ...params,
                };
                axios.post(url, queryParam).then(resp => {
                    this.loading = false;
                    if (resp.data.data.success) {
                        this.data = resp.data.data.datas.list;
                        this.total = resp.data.data.datas.total;
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1')
                        });
                    }
                });
            },
            /* 获取库存组织 */
            getOrganizationName: function () {
                this.getSRMInvLovListNew((data) => {
                    const orgList = data.map(({ organizationName, organizationCode, erpOrgId }) => {
                        return {
                            label: organizationName,
                            value: erpOrgId,
                            erpOrgId,
                            organizationCode,
                        };
                    });
                    this.getFormDataItemObj(this.formData.items, 'organizationId').options.values = orgList;
                    this.orgList = orgList;
                });
            },
            column2Fields(cols) {
                let fields = {};
                cols.forEach(col => {
                    if (col.key) {
                        fields[col.key] = col.title;
                    }
                });
                return fields;
            },
            /* 获取事务处理类型 */
            getTransactionType() {
                // let url = '/gscint/ierp/tackBackDetail/revTransactionType'
                // axios.post(url, {
                //     'name': 'revTransactionType',
                //     'parameter': [{name: 'pageSize', value: 99}, {name: 'countStatus', value: 'N'}, {
                //         name: 'pageIndex',
                //         value: '1'
                //     }],
                //     'append': ''
                // }).then(resp => {
                //     if (resp.data.data.success) {
                //         this.formData.items.map((item) => {
                //             if (item.field === 'transactionType') {
                //                 item.options.values = resp.data.data.datas;
                //                 return false;
                //             }
                //         });
                //     }
                // }).catch(err => {
                //     this.$Modal.error({
                //         title: this.$t('common.warn'),
                //         content: this.$t('common.error1'),
                //         error: err.stack.toString()
                //     });
                // });
                this.getDictByCode('INT_RCV_TRANSACTION_TYPE', (data) => {
                    this.getFormDataItemObj(this.formData.items, 'transactionType').options.values = data;
                });
            },
            onSelectChange(value) {
                this.gender = value;
            },
            onSubmit(current, pageSize, condition) {
                this.condition = condition;
                this.pages = 1;
                this.pageSize = pageSize;
                this.seach();
            },
            // 页容量改变时触发
            onPageSizeChange(currentPage, pageSize, condition) {
                this.pageSize = pageSize;
                this.seach();
            },
            // 当前页改变时触发
            onCurrentPageChange(current) {
                this.pages = current;
                this.seach();
            },
            onView(row, column, index) {
                // alert('查看按钮点击事件');
            },
            onEdit(row, column, index) {
                // alert('编辑按钮点击事件');
            },
            onDelete(row, column, index) {
                // alert('删除按钮点击事件');
            },
            onRowClick(row, index) {
                // alert('点击了第 ' + index + ' 行');
            },
            onSelect(selection, row) {
                // alert('选中了名字为 ' + row.name + ' 的数据');
            },
            onSelectAll(selection) {
            },
            filterLang() {
              if (this.currLang === 'zh-CN') {
                  return 'ZHS';
              } else if (this.currLang === 'en-US') {
                  return 'US';
              } else if (this.currLang === 'ja-JP'){
                  return 'JA';
              } else {return 'ZHS'};
            },
            // 时区转换
            timeChange (orgCode, time) {
                // let timeOffset = new Date().getTimezoneOffset() + 480;
                let orgObj = this.INT_TIME_ZONE.find((item) => item.code === orgCode);
                if (orgObj && orgObj.value) {
                    return moment(time).add(orgObj.value, 'h').format('YYYY-MM-DD HH:mm:ss');
                } else {
                    return time;
                }
            },
            getOrgCode(params) {
                const org = this.orgList.find((item) => item.value === params.organizationId);
                return org && org.organizationCode;
            },
        },
        mounted() {
            this.vendorUser = JSON.parse(localStorage.getItem('user'));
            axios.get('/gscint/vendor/getVendorIERP', {
                // params: {
                //     loginName: this.vendorUser.loginName // 运维切换账号需要
                //     // isReLoad: 1 // 一般都不传
                // }
            }).then(res => {
                if (res.data.data.success) {
                    this.vendorId = res.data.data.datas.vendorId;
                    this.vendorCode = res.data.data.datas.vendorCode;
                    this.mdmCode = res.data.data.datas.mdmCode; // 为IERP的供应商编码
                }
                this.loading = false;
                let today = new Date();
                let mouth = today.getMonth();
                let prevToday = today.setMonth(mouth - 1);
                this.formData.items[1].value = prevToday;
                this.getOrganizationName();
                this.getTransactionType();
            });
            this.getDictByCode('INT_TIME_ZONE');
            this.getDictByCode('INT_LOCAL_PO_ORG');
        }
    };
</script>

<style scoped>

</style>
<style lang="less">
.rcvReturnSearchLayout .m-form .m-form-item-label {
    padding: 10px 10px 10px 0;
    letter-spacing: -0.8px;
}
</style>
